import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FilterCollapsiblePanel } from "../mobile/FilterCollapsible";
import { SDP_PRODUCTS_FILTERS_KEY, HOTEL_ONLY_PRODUCTS_FILTERS_KEY } from "app/constants";
import { TripAdvisor } from "app/icons/brands/TripAdvisor";
import PropTypes from "prop-types";
import "./FilterDrawerFormPanel.scss";
import { FacetFilter } from "../FacetFilter";

export const FilterDrawerFormPanel = ({
	facetId,
	facetTitle,
	filters,
	selectedFiltersCount,
	...props
}) => {
	return (
		<FilterCollapsiblePanel
			className="filter-drawer-form-panel"
			title={
				<div className="filter-drawer-form-panel__collapsible-title">
					<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold component="h3">
						{facetTitle}

						{selectedFiltersCount > 0 && ` (${selectedFiltersCount})`}
					</Typography>

					{(facetId === SDP_PRODUCTS_FILTERS_KEY.GUESTS_RATING ||
						facetId === HOTEL_ONLY_PRODUCTS_FILTERS_KEY.TRIPADVISOR) && (
						<TripAdvisor size={24} />
					)}
				</div>
			}
			{...props}
		>
			{filters.map(filter => (
				<FacetFilter key={filter.field} filter={filter} />
			))}
		</FilterCollapsiblePanel>
	);
};

FilterDrawerFormPanel.propTypes = {
	facetId: PropTypes.string.isRequired,
	facetTitle: PropTypes.string.isRequired,
	filters: PropTypes.array.isRequired,
	selectedFiltersCount: PropTypes.number,
};
